import { render, staticRenderFns } from "./POStestlist2.vue?vue&type=template&id=674f988a&scoped=true"
import script from "./POStestlist2.vue?vue&type=script&lang=js"
export * from "./POStestlist2.vue?vue&type=script&lang=js"
import style0 from "./POStestlist2.vue?vue&type=style&index=0&id=674f988a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674f988a",
  null
  
)

export default component.exports